import { useRef, useState, useEffect } from 'react';
import { randomString } from '@togglecorp/fujs';

const resizeHandlers = {};
const handleResize = entries => {
  entries.forEach(entry => {
    const element = entry.target;
    if (element instanceof HTMLElement) {
      const key = element.dataset.resizeHandlerKey;
      if (key && resizeHandlers[key]) {
        const {
          contentRect: rect
        } = entry;
        resizeHandlers[key](rect);
      }
    }
  });
};
const observer = new ResizeObserver(handleResize);
const addResizeHandler = (ref, callback) => {
  const key = randomString(16);
  if (!ref.current) {
    return;
  }
  // eslint-disable-next-line no-param-reassign
  ref.current.dataset.resizeHandlerKey = key;
  resizeHandlers[key] = callback;
  observer.observe(ref.current);
};
const removeResizeHandler = ref => {
  if (!ref.current) {
    return;
  }
  observer.unobserve(ref.current);
  const key = ref.current.dataset.resizeHandlerKey;
  if (!key || !resizeHandlers[key]) {
    return;
  }
  delete resizeHandlers[key];
};
const useDimension = function (targetRef) {
  let debounceDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  const timeoutRef = useRef();
  const [rect, setRect] = useState(undefined);
  useEffect(() => {
    if (!targetRef) {
      return () => {
        // noop
      };
    }
    addResizeHandler(targetRef, r => {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        const different = !rect
        // || r.x !== rect.x
        // || r.y !== rect.y
        || r.width !== rect.width || r.height !== rect.height || r.top !== rect.top || r.right !== rect.right || r.bottom !== rect.bottom || r.left !== rect.left;
        if (different) {
          setRect(r);
        }
      }, debounceDuration);
    });
    return () => {
      window.clearTimeout(timeoutRef.current);
      removeResizeHandler(targetRef);
    };
  });
  return rect;
};

export { useDimension as default };
//# sourceMappingURL=useDimension.js.map
